import React, { useContext } from "react";
import ResponseStatusContext from "./response-status";
import "./not-found.scss";

const NotFound = () => {
  const responseStatus = useContext(ResponseStatusContext);

  if (responseStatus) {
    responseStatus.code = 404;
  }

  return (
    <div className="Page">
      <div className="NotFound">
        <div className="NotFound-inner">404 Page not found</div>
      </div>
    </div>
  );
};

export default NotFound;
